import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { Service } from '../data/services';

/**
 * BLOCK PART: service card
 * ACF: rendered from a `service` CPT record inside `block_services_grid`.
 *
 * Takes the whole Service record rather than loose props, so the homepage and
 * the Start Your Journey page can no longer drift apart in wording — the copy
 * override object that used to live in Home.tsx has been folded into
 * data/services.ts (`shortTitle`, `cardSummary`, `exploreLabel`).
 */

interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  return <article className="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-soft transition-transform duration-300 hover:-translate-y-1" data-id="element-377" data-mp="39d2fhhutpxhb">
      <div className="aspect-[4/3] overflow-hidden" data-id="element-378" data-mp="3j9yorpsjqnmx">
        <img src={service.image} alt={service.imageAlt} loading="lazy" decoding="async" width={800} height={600} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-379" data-mp="3o8088btvwoyx" />
      </div>

      <div className="flex flex-grow flex-col p-8" data-id="element-380" data-mp="1zd1zyn3aoxim">
        <h3 className="mb-4 font-serif text-2xl leading-tight text-charcoal" data-id="element-381" data-mp="1ucdzzbx396c9">
          {service.shortTitle}
        </h3>
        <p className="mb-6 flex-grow font-light leading-relaxed text-charcoal-50" data-id="element-382" data-mp="1qbu1o50s3woj">
          {service.cardSummary}
        </p>

        <div className="mt-auto border-t border-cream-200 pt-6" data-id="element-383" data-mp="2i16z1h90bub3">
          <p className="mb-6 font-medium text-sage-700" data-id="element-384" data-mp="2i1yw6wi9603h">{service.price}</p>

          <div className="flex items-center justify-between gap-4" data-id="element-385" data-mp="2d9f8h6pupoky">
            <Link to="/lets-connect" className="rounded-full bg-sage px-6 py-2.5 text-sm tracking-wide text-white transition-colors hover:bg-sage-600 focus:outline-none focus:ring-2 focus:ring-sage-700 focus:ring-offset-2" aria-label={`Enquire about ${service.shortTitle}`} data-id="element-386" data-mp="2994yzk2uog1c">
              Join a Session
            </Link>
            <Link to={service.link} className="group flex items-center text-sm text-charcoal-50 transition-colors hover:text-sage-700 focus:outline-none focus:ring-2 focus:ring-sage-700 focus:ring-offset-4" aria-label={`${service.exploreLabel}: ${service.shortTitle}`} data-id="element-387" data-mp="z4vbezlvji51">
              {service.exploreLabel}
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-388" data-mp="gag8x00ct7cg" />
            </Link>
          </div>
        </div>
      </div>
    </article>;
}